import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface OrganizationData {
  id: string;
  name: string;
  description: string | null;
  purpose: string | null;
  key_programs: string | null;
  effect_measurement: string | null;
  latest_grants: string | null;
}

export const useOrganization = () => {
  return useQuery({
    queryKey: ["current-organization"],
    queryFn: async (): Promise<OrganizationData | null> => {
      // Get current user
      const { data: { user }, error: userError } = await supabase.auth.getUser();
      if (userError || !user) {
        return null;
      }

      // Get user's profile to find organization_id
      const { data: profile, error: profileError } = await supabase
        .from("profiles")
        .select("organization_id")
        .eq("id", user.id)
        .single();

      if (profileError || !profile?.organization_id) {
        return null;
      }

      // Fetch organization details
      const { data: organization, error: orgError } = await supabase
        .from("organizations")
        .select("id, name, description, purpose, key_programs, effect_measurement, latest_grants")
        .eq("id", profile.organization_id)
        .single();

      if (orgError || !organization) {
        return null;
      }

      return organization;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
